const map = {
	"./EnvConfig": 1208,
	"./EnvConfig.js": 1208,
	"./base": 1328,
	"./base.js": 1328,
	"./perf": 9914,
	"./perf.js": 9914,
	"./prod": 1048,
	"./prod.js": 1048,
	"./qa": 7035,
	"./qa.js": 7035,
	"./sandbox": 482,
	"./sandbox.js": 482,
	"./sinperf": 7308,
	"./sinperf.js": 7308,
	"./sinprod": 2066,
	"./sinprod.js": 2066,
	"./sit": 5661,
	"./sit.js": 5661,
	"./stg": 2037,
	"./stg.js": 2037
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6391;